import { render } from "./ScanAndPaySection.vue?vue&type=template&id=8f7f36d8&scoped=true"
const script = {}

import "./ScanAndPaySection.vue?vue&type=style&index=0&id=8f7f36d8&scoped=true&lang=css"

import exportComponent from "/home/armin/w/euro-petrol-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f7f36d8"]])

export default __exports__